module.exports = __webpack_public_path__ + "img/img_throw_6@3x_v3.10c012e5.png";